import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./notFound.css";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="notfound_content">
      <h3>{t("NOTFOUND.TITLE")}</h3>
      <Link to="/" className="notfound_link">
        {t("NOTFOUND.LINK")}
      </Link>
    </div>
  );
};

export default NotFound;
